<template>
<v-app id="app" class="navbar-top" >

    <!-- Page container -->
    <v-content class="page-container d-flex" ><!--:style="{'background-image': 'url(' + require('@/assets/images/fondoFibra_rec.jpg') + ')'}"-->
      <!-- Page content -->
        <the-sidebar />
        <!-- Main content -->
        
          <!-- Content area -->
          <!-- <div class="content"> -->
          <div class="mobile-layout">
           <v-toolbar   class="elevation-0"><the-navbar /></v-toolbar>
            <v-container fluid class="my-0 col-12 pa-0 container">
              <router-view :key="$route.fullPath"/>
            </v-container>
          </div>
          <!-- </div> -->
          <!-- /Content area -->
       
        <!-- /Main content -->

      <!-- /Page content -->
      <!-- alerta -->
        <alerta :error='error' :errors='errors' :color='colorAlerta' @closeError="error=false" />
      <!-- FIN alerta -->
        <confirm ref="confirm"></confirm>
    </v-content>
    <!-- /Page container -->
  
</v-app>
</template>
<script>
import TheNavbar from "./components/TheNavbar.vue";
import TheSidebar from "./components/TheSidebar.vue";
import Alerta from '@/components/Alerta.vue';
import Confirm from '@/components/Confirm.vue';

export default {
  name: "app",
  components: {
    "the-navbar": TheNavbar,
    "the-sidebar": TheSidebar,
    Alerta,
    Confirm
  },
  sockets: {
      connect: function () {
        console.log('socket connected')
      },
      conexion_duplicada: function (data) {
        if (data.sesion == this.$store.getters.getSesion) {
          var url = "/login"
          if (this.isSys4Conjunto()) {
            url += '/' + localStorage.getItem('instalacion')
          }
          this.$store.reset()
          this.$store.commit('logout')
          this.$router.push(url)
        }
      },
      conexion_inactiva: function (data) {
        if (data.sesion == this.$store.getters.getSesion) {
          var url = "/login"
          if (this.isSys4Conjunto()) {
            url += '/' + localStorage.getItem('instalacion')
          }
          this.$store.reset()
          this.$store.commit('logout')
          this.$router.push(url)
        }
      }
  },
  data () {
    return {
      error: false,
      errors: [],
      colorAlerta: '',   
    }
  },
  mounted() {
    this.$root.$on('mostrarAlerta', (mensajes, color) => {
      this.mostrarAlerta(mensajes, color)
    });
    this.$root.$confirm = this.$refs.confirm
  },
  created() {
    if (this.$store.getters.getSesion == null) {
      this.$store.commit('setSesion', this.uniqid())
    } else {
      // console.log(this.$store.getters.getSesion);
    }
    this.emitirPing()
  },
  methods: {
    mostrarAlerta (mensajes, color) {
      this.error = true
      this.errors.length = 0
      this.errors.push(mensajes)
      this.colorAlerta = color
    },
    emitirPing() {
      var vue = this
      setInterval( function() {
        if (vue.$store.getters.getSesion === null) {
          vue.$store.commit('setSesion', vue.uniqid())
        }
        // console.log(vue.$store.getters.getSesion)
        vue.$socket.emit("ping", vue.$store.getters.getSesion);
      }, 5000);
    },
    uniqid(prefix = "", random = false) {
      const sec = Date.now() * 1000 + Math.random() * 1000;
      const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
      return `${prefix}${id}${random ? `.${Math.trunc(Math.random() * 100000000)}`:""}`;
    }
  },
};
</script>